import { ApiError } from '../../shared/api'

/**
 * The code the API sends when the email provider refused the address itself.
 * It arrives as a 422, the same status the hunt-guest invite uses for "this hunt
 * has no join code", so callers match on the code and check it first.
 */
export const RECIPIENT_REJECTED_CODE = 'notification.recipient_rejected'

export function isRecipientRejected(e: unknown): boolean {
  return e instanceof ApiError && e.problem.code === RECIPIENT_REJECTED_CODE
}
